import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledWalletAwardsSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${toRem(32)};
  border-radius: ${toRem(16)};
`;
export const StyledAwardsContainer = styled.div``;
export const StyledDivider = styled.hr`
  border: 0;
  border-top: ${toRem(1)} solid ${baseVariables.color['neutral20']};
  height: 0;
  width: 100%;
  margin: ${toRem(12)} 0;
  opacity: 1;
`;
export const StyledEmptyStateCard = styled.div`
  justify-content: space-between;
  gap: ${toRem(16)};
  padding: ${toRem(16)};
  border: ${toRem(1)} dashed ${baseVariables.color['neutral30']};
  border-radius: ${toRem(16)};
  background-color: ${baseVariables.color['white']};
  .wallet-awards-section__summary {
    min-width: 0;
    gap: ${toRem(16)};
  }
  .wallet-awards-section__icon-wrapper {
    width: ${toRem(48)};
    height: ${toRem(48)};
  }
  .wallet-awards-section__icon {
    font-size: ${toRem(36)};
    line-height: 1;
  }
  .wallet-awards-section__content {
    min-width: 0;
    gap: ${toRem(4)};
  }
  @media ${baseVariables.mediaQuery.md} {
    align-items: center;
    flex-direction: row;
    padding: ${toRem(24)};
  }
`;
